var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 22,
    viewBox: "0 0 87 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.3058 0.5H2.97521C1.33205 0.5 0 1.83205 0 3.47521V18.3512C0 19.9944 1.33205 21.3265 2.97521 21.3265H83.3058C84.949 21.3265 86.281 19.9944 86.281 18.3512V3.47521C86.281 1.83205 84.949 0.5 83.3058 0.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecButton);
export default __webpack_public_path__ + "static/media/RecButton.a321935ae1bf7ff52a13e5a730cd39a3.svg";
export { ForwardRef as ReactComponent };